import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, toString } from 'lodash/fp';

import { GeoLocationSuggestControl } from 'components/forms/GeoLocationSuggest';
import {
  DISTANCE_NAME,
  DEFAULT_GEOLOCATION_DISTANCE,
} from 'components/searchAds/constants';

export default class GeoLocationControl extends PureComponent {
  static propTypes = {
    input: PropTypes.object,
  };

  handleChange = (geoLocation) => {
    const { input } = this.props;
    const {
      value: { distance },
    } = input;

    if (isEmpty(geoLocation)) {
      return input.onChange(geoLocation);
    }

    input.onChange({
      ...geoLocation,
      [DISTANCE_NAME]: distance || toString(DEFAULT_GEOLOCATION_DISTANCE),
    });
  };

  render() {
    const { input } = this.props;

    return (
      <GeoLocationSuggestControl
        {...this.props}
        input={{
          ...input,
          onChange: this.handleChange,
        }}
      />
    );
  }
}
